import { checkPropTypes } from 'prop-types'
import React from 'react'

export default function ViewIcon({ styles, width, height }) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 9C11.206 9.00524 10.4459 9.32299 9.88447 9.88447C9.32299 10.4459 9.00524 11.206 9 12C9 13.642 10.358 15 12 15C13.641 15 15 13.642 15 12C15 10.359 13.641 9 12 9Z"
        fill="#565656"
      />
      <path
        d="M2.38275 12.3465C2.4015 12.3975 2.43 12.4688 2.469 12.5602C2.57175 12.801 2.69325 13.0522 2.82975 13.3073C3.129 13.8667 3.64875 14.7112 4.4265 15.5565C6.40875 17.709 8.9865 18.8002 12.0893 18.8002C15.1927 18.8002 17.7705 17.709 19.7528 15.5565C20.529 14.7127 21.0495 13.8675 21.3495 13.308C21.4837 13.0568 21.6053 12.8055 21.7103 12.5595C21.7478 12.4703 21.777 12.3982 21.795 12.348L21.9053 12.0247L21.7957 11.7022C21.7778 11.6527 21.7485 11.5807 21.7103 11.4908C21.606 11.247 21.4845 10.995 21.3503 10.743C21.0502 10.1827 20.529 9.33825 19.7528 8.4945C17.772 6.342 15.1935 5.25 12.09 5.25C8.98575 5.25 6.408 6.342 4.4265 8.4945C3.651 9.3375 3.1305 10.1827 2.82975 10.743C2.658 11.064 2.53875 11.3265 2.469 11.4908C2.43075 11.5815 2.40225 11.6535 2.3835 11.703L2.37 11.739L2.25 11.7405L2.35725 11.775L2.27325 12.0255L2.38275 12.3465ZM3.957 11.9355C4.482 10.731 6.618 6.80025 12.09 6.80025C17.5605 6.80025 19.698 10.731 20.223 11.9355L20.2612 12.0255L20.223 12.114C19.698 13.3193 17.5627 17.25 12.09 17.25C6.61725 17.25 4.482 13.3193 3.957 12.1147L3.918 12.0247L3.957 11.9355Z"
        fill="#565656"
      />
    </svg>
  )
}

ViewIcon.propTypes = {
  styles: checkPropTypes.any,
  width: checkPropTypes.string,
  height: checkPropTypes.string,
}
